import { createSlice } from '@reduxjs/toolkit'

export const TasksOnSameDateSlice = createSlice({
  name: 'tasks_same_date',
  initialState: {
    value: [[],'','',''],
  },
  reducers: {
    tasksSameDate: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { tasksSameDate } = TasksOnSameDateSlice.actions

export default TasksOnSameDateSlice.reducer